import { ReactNode, useState } from 'react';
import Sidebar, { FixedSidebarItem } from '../Layouts/AuthLayout/Sidebar';
import {
  MobileSidebar,
  MobileSidebarItem,
} from '../Layouts/AuthLayout/MobileSidebar';
import { sidebarData } from '../Common/constants';
import LeftSide from './NonAuthLayout/LeftSide';
import Logo from '../Common/Logo';
import Header from './AuthLayout/Header';
import { useLocation, useMatch } from 'react-router-dom';

interface LayoutProps {
  children?: ReactNode;
}

export const AuthLayout = ({ children }: LayoutProps) => {
  const [sidebarExpanded, setSidebarExpanded] = useState<boolean>(true);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState<boolean>(false);

  const handleMobileSidebarToggle = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };

  const handleMobileSidebarClose = () => {
    setMobileSidebarOpen(false);
  };

  const matchWithCompany = useMatch('/settings/company-details');
  const matchWithPublic = useMatch('/settings/public-profile');

  const match = matchWithCompany || matchWithPublic;

  const location = useLocation();
  const talentOnboardingMatch =
    location.pathname === '/agency-talents/basic-info' ||
    location.pathname === '/agency-talents/professional-experience' ||
    location.pathname === '/agency-talents/intro-video' ||
    location.pathname === '/agency-talents/pay-settings' ||
    location.pathname === '/work-offers' ||
    location.pathname === '/agency-talents' ||
    location.pathname.includes('/agency-talents/view') ||
    location.pathname.includes('/agency-talents/edit') ||
    location.pathname.includes('/agency-talents/update');
  return (
    <div className="flex min-h-screen">
      {/* Desktop Fixed Sidebar */}
      <div className="hidden min-991:block fixed left-0 top-0 z-50 h-full">
        <Sidebar onToggle={setSidebarExpanded}>
          {(expanded: boolean) =>
            sidebarData.map((item, index) => (
              <FixedSidebarItem
                key={index}
                icon={item.icon}
                activeIcon={item.sec}
                hoverIcon={item.hover}
                text={item.title}
                path={item.path}
                expanded={expanded}
              />
            ))
          }
        </Sidebar>
      </div>

      {/* Mobile Sidebar Drawer */}
      <MobileSidebar
        isOpen={mobileSidebarOpen}
        onClose={handleMobileSidebarClose}
      >
        {sidebarData.map((item, index) => (
          <MobileSidebarItem
            key={index}
            icon={item.icon}
            activeIcon={item.sec}
            text={item.title}
            path={item.path}
            onClose={handleMobileSidebarClose}
          />
        ))}
      </MobileSidebar>

      <div
        className={`flex-1 flex flex-col min-w-0 relative transition-all duration-300 ${
          sidebarExpanded ? 'min-991:ml-[220px]' : 'min-991:ml-[60px]'
        }`}
      >
        {/* Header */}
        <Header onMobileSidebarToggle={handleMobileSidebarToggle} />

        {/* Main content */}
        <main
          className={`flex-1 ${
            !match && !talentOnboardingMatch ? 'p-4 min-991:p-6' : ''
          }`}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export const NonAuthLayout = ({ children }: LayoutProps) => {
  return (
    <div className={`grid min-991:grid-cols-2 min-h-screen`}>
      <LeftSide />
      <div className="max-w-xl w-full mx-auto pt-6 relative flex flex-col justify-between [&>*]:w-full">
        <div className="min-991:hidden">
          <Logo />
        </div>
        {children}
        <p className="text-center pt-2 text-[#6B7280] text-sm mb-10">
          Trusted by 10,000+ engineers worldwide
        </p>
      </div>
    </div>
  );
};
